import { splitFrontmatter } from './split-frontmatter.util';

/**
 * Strip a leading `---…---` frontmatter block and return the body.
 *
 * Content with no closed leading fence is returned unchanged. Use this when the block is only being
 * hidden; use `splitFrontmatter` when the block has to survive a round-trip through an editor.
 *
 * Ported from Clarity `apps/web/src/shared/utils/frontmatter.ts`.
 */
export function stripFrontmatter(content: string): string {
	return splitFrontmatter(content).body;
}
